export default "__VITE_ASSET__CLb2mb2Y__"